import CatchErrors from 'components/common/catch-errors';
import ImportParts from 'components/stock-parts/import-parts';
import React from 'react';
import StockPartDashboard from 'components/stock-parts/stock-part/stock-part-dashboard';
import StockPartTabs from 'components/stock-parts/stock-part/stock-part-tabs';
import StockPartsForm from 'components/stock-parts/stock-part/stock-part-form/stock-part-form';
import StockPartsSearch from 'components/stock-parts/stock-parts-search';
import { Route } from "react-router-dom";

const StockParts = (props) => {

	return (
		<div className="col-12">
			<div className="row">
				{/* --------------------------------------------------------------------------
								|----first col----|--------center col--------|--third col-|
					COLUMN 1 - /:handle/stock_parts/:stock_part_id/:form/:form_id/:tab/:tab_id
				--------------------------------------------------------------------------- */}

				<Route
					path={props.match.path + "/:asset_type_id?/:stock_part_id?"} render={(route_props) => (
						<div id="column1" className="column col-8 animate-opacity" style={{ height: 'calc(100vh - 100px)', overflow: 'hidden' }}>
							<div className='row justify-content-between'>
								<div className='col'>
									<h1><strong>STOCK PARTS</strong></h1>
								</div>
								<ImportParts />
							</div>
							<CatchErrors>
								<StockPartsSearch {...route_props} />
							</CatchErrors>
						</div>
					)}
				/>

				{/* --------------------------------------------------------------------------
								|----first col----|--------center col--------|--third col-|
					COLUMN 2 - /:handle/stock_parts/:stock_part_id/:form/:form_id/:tab/:tab_id/
				-------------------------------------------------------------------------- */}

				<Route
					path={props.match.path + "/:stock_part_type/:stock_part_id/:form/:form_id/:tab?/:tab_id?"}
					render={(route_props) => (
						<div id="column2" className="column col-4 animate-left">
							<CatchErrors>
								<StockPartDashboard />
							</CatchErrors>
							<CatchErrors>
								<StockPartTabs {...route_props} />
							</CatchErrors>
						</div>
					)}
				/>

				{/* ----------------------------------------------------------------------
					MODALS
				---------------------------------------------------------------------- */}

				<Route path={props.match.path + "/:asset_type_id/:stock_part_id?/stock-part-form/:form_id?"}
					render={(route_props) => (
						<CatchErrors modal={true}>
							<StockPartsForm {...route_props} />
						</CatchErrors>
					)}
				/>
			</div>
		</div>
	);
};
export default StockParts

